<template>
   <div class='h100vh-100'>
    <div class="h-toolbarBg">
      <ejs-toolbar>
        <e-items>
          <e-item prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Common.refresh")' :click="querySameData"></e-item>
        </e-items>
      </ejs-toolbar>
      <div class="h-inputBox">
        <div class="h-barLit">{{$t('System.curMoKey')}}</div>
        <ejs-dropdownlist id='dropdownlist' ref="dropdownlist" width="220" :index=0 v-model="dropValue" :dataSource="sportsData" :fields="fields" :change='onChange' :placeholder='$t("System.pleaseChoose")'></ejs-dropdownlist>
        <div class="h-barSpace20" style="width:50px;">{{$t('System.curMoValue')}}</div>
        <ejs-dropdownlist id='dropdownlistValue' ref="dropdownlistValue"  width="220" :index=0 v-model="keywords" :dataSource="valueData"  :change='querySameData'  :placeholder='$t("System.pleaseChoose")'></ejs-dropdownlist>
      </div>
    </div>
    <div class="h100-40 h-scroll">
      <RightGlobalTable ref="rightGlobalTable"></RightGlobalTable>
    </div>
    </div>

  </template>
  <script>
    import Vue from 'vue';
    import {createNamespacedHelpers} from 'vuex';
    import CommandExec from '@/components/mmlconfig/rightPanel/CommandExec.vue';
    import RightGlobalTable from '@/components/mmlconfig/rightPanel/RightGlobalTable.vue';
    import ModRecords from '@/components/mmlconfig/rightPanel/ModRecords.vue';
    import clearMoVuex from '@/components/mmlconfig/mixins/clearMoVuex';
    import packageParams from '@/components/mmlconfig/mixins/packageParams';
    import { Query } from '@syncfusion/ej2-data';
    import { DropDownListComponent as EjsDropdownlist } from "@syncfusion/ej2-vue-dropdowns";
    import bus from '../bus.js';
    import { EventBus } from '../../../plugins/eventBus';
    import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
    Vue.use(DropDownListPlugin);
    const {mapGetters, mapMutations} = createNamespacedHelpers('mmlconfig');
    export default {
      name: 'right-panel',
      components: {
        CommandExec,
        RightGlobalTable,
        ModRecords
      },
      mixins: [clearMoVuex, packageParams],
      data() {
        return {
          // 命令行清除计算标识 eg.经高危操作提示，用户取消操作后，仍保留该行mml在codemirror中
          sportsData: [],
          fields: { text: 'Name', value: 'Id' },
          allowFiltering: true,
          keywords:'',
          valueData:[],
          dropValue: '0',
          moCurName:'',
          refresh: true,
          modRecords: [],
          modColumns: [],
          cmdList: [],
          dangerOperChecked: false,
          showMassModRecords: false,
          localeLan:'zh',
          execTime: 0
        };
      },
      watch: {
        massModifyMode(newV) {
          // 若不是批量修改模式，需要隐藏
          console.log('massModifyMode change:', newV);
          if (!newV) {
            this.showMassModRecords = false;
          }
        }
      },
      computed: {
        ...mapGetters(['currentNode', 'currentMo', 'massModifyMode', 'isMassModExecing', 'cmdMode']),
      },
      created() {
        sessionStorage.setItem("mml_export_mos", "");
        bus.$on('refreshAndLoadTabsGlobal', (moData) => {
          this.moCurName= moData.moName;
          this.refreshCommandExec(moData);
        });
        bus.$on('showMassModRecord', (modRecords) => {
          this.showMassModRecord(modRecords);
          this.$refs.mmlModRecords.clearSelectedRows();
        });
      },
      mounted() {
         this.localeLan = localStorage.getItem('locale');

        console.log('---------rightPanel-------',this.localeLan);
      },
      methods: {
        ...mapMutations(['changeMo', 'changeCommand', 'changeMassModMode', 'changeMassModExecingState',
          'changeCmdMode', 'changeMmlOperButtonDisabled', 'changeMmlCmdButtonDisabled']),
        refreshCommandExec(moData) {
          this.sportsData=[];
          console.log("======moData=========",moData);
          moData.attributes.forEach((item, index, arr) => {
           //  console.log(item, item.id, index, arr);
          let JSON= {
                Name:'',
                Id:''
            }
            if(this.localeLan=='zh'){
              JSON.Name = item.zhName;
              JSON.Id = item.name;
            }else{
              JSON.Name = item.enName;
              JSON.Id = item.name;
            }
            this.sportsData.push(JSON);
      });
      this.$refs.dropdownlist.ej2Instances.dataSource=this.sportsData;
      this.$refs.dropdownlist.ej2Instances.fields={ text: 'Name', value: 'Id' };
        },

        filtering: function(e) {
             var searchData = this.sportsData;
             if(e.text == '') e.updateData(searchData);
              else{
              // restrict the remote request until search key contains 3 characters.
                  if (e.text.length < 3) { return; }
                  var query = new Query().select(['Name', 'Id']);
                  query = (e.text !== '') ? query.where('Name', 'startswith', e.text, true) : query;
                  e.updateData(searchData, query);
              }
          },
          querySameData() {
           if(typeof(this.keywords)==undefined || this.keywords ==''){
            EventBus.$emit('toast', {type: 'warning', content: this.$t('Topo.pleaseSelect')});
            return;
           }

           const params = {
            neId: this.currentNode.id,
            moName: this.moCurName,
            key: this.dropValue,
            value:this.keywords,
            pageNo:1,
            pageSize:20
          };
           this.$refs.rightGlobalTable.getParamListData(params);
        },
        updateKeywords(clickEvent) {
          if (clickEvent.keyCode === 13) {
            querySameData();
          }
        },
        keydownFunc(clickEvent) {
          this.$emit('notify', 'keywords');
        },
        syncTreeData(treeData) {
          console.log("syncTreeData",treeData)
        },
        onChange(){
            const params = {
            neId: this.currentNode.id,
            moName: this.moCurName,
            key: this.dropValue,
          };
          this.$axios.post('/lte/ems/config/mml/queryCurMoDataByKey',params).then((response) => {
              if (response && response.status === 200) {
                const result = response.data.resultVal;
                this.valueData = result.data;
                this.$refs.dropdownlistValue.ej2Instances.dataSource=result.data;
              } else {
                EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
              }
            });
        }
      },
      beforeDestroy() {
        bus.$off('refreshAndLoadTabsGlobal');
        bus.$off('showMassModRecord');
        }
    };
  </script>

  <style>

  </style>
